<template>
<div class="manage-folder">
    <div class="title">
        <h1 class="">Folder</h1>
    </div>
    <FolderOpenView @folder-open="OnFolderOpen" v-if="!hideFolderOpenView" :folder-name="FolderName" />
    <div v-else>
        <div class="search">
            <div class="paths" style="border: 1px solid #D05959">
                <label class="mdi mdi-folder" style="background-color: #D05959; color: #fff; margin: 0px; padding: 5px 10px 5px 10px"> : <span class="directory">Directory</span> </label>&nbsp;&nbsp;
                <div>
                  <div class="pathUrl" style="display: flex; flex-wrap: wrap; align-content: center;">
                    <span style="inline" v-for="(path,idx) in absolutePath" :key="idx">
                        <div class="path" @click="navigate(path)">{{path.path}}/</div>
                    </span>
                  </div>  
                </div>
            </div>
        </div>
        <div class="files-table">
            <table class="table">
                <tr v-for="data in folderDataList" :key="data">
                    <td class="file-row">
                        <div class="flex-nowrap">
                          <div style="flex: 0 0 5%">
                              <img class="folderImg" :src="folderImg" alt="">
                          </div>
                          <div class="fileNameContainer" style="flex: 0 0 70%">
                              <label class="fileName">{{ data['name'] }} </label>
                          </div>
                        </div>
                        <div class="btn-holder">
                            <div class="button-holder">
                                <div class="edit-button-holder" @click="openSubFolder(data)">
                                    <img :src="folderOpenIcon" class="open-folder-button" alt="">
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
            <table class="table">
                <tr>
                    <td style="width:80%;padding:0px;">
                        <div class="files" v-for="(files,index) in fileDataList" :key="index">
                            <div class="flex-nowrap">
                                <div class="file-type-holder">
                                  <img :src="pdfIcon" v-if="files.name.toLowerCase().endsWith('pdf')" class="fileImg" alt="">
                                  <img :src="docxIcon" v-if="files.name.toLowerCase().endsWith('docx')" class="fileImg" alt="">
                                  <img :src="docxIcon" v-if="files.name.toLowerCase().endsWith('doc')" class="fileImg" alt="">
                                  <img :src="pngIcon" v-if="files.name.toLowerCase().endsWith('png')" class="fileImg" alt="">
                                  <img :src="jpgIcon" v-if="files.name.toLowerCase().endsWith('jpg')" class="fileImg" alt="">
                                  <img :src="jpegIcon" v-if="files.name.toLowerCase().endsWith('jpeg')" class="fileImg" alt="">
                                  <img :src="xlsxIcon" v-if="files.name.toLowerCase().endsWith('xlsx')" class="fileImg" alt="">
                                  <img :src="txtIcon" v-if="files.name.toLowerCase().endsWith('txt')" class="fileImg" alt="">
                                  <img :src="pptIcon" v-if="files.name.toLowerCase().endsWith('ppt')" class="fileImg" alt="">
                                  <img :src="pptIcon" v-if="files.name.toLowerCase().endsWith('pptx')" class="fileImg" alt="">
                                  <img :src="csvIcon" v-if="files.name.toLowerCase().endsWith('csv')" class="fileImg" alt="">
                                  <img :src="zipIcon" v-if="files.name.toLowerCase().endsWith('zip')" class="fileImg" alt="">
                              </div>
                              <div class="font-weight-bold file-Name">{{files.name}}</div>
                            </div>
                            
                            <div class="button-holder">
                                <div class="edit-button-holder" v-if="files.name.toLowerCase().endsWith('pdf') && getViewerName(files.viewerUserId) == null" @click="openDocument(formatPreviewData(files))">
                                    <img :src="previewIcon" class="preview-button" alt="">
                                </div>
                                <div class="edit-button-holder" v-if="files.name.toLowerCase().endsWith('txt') && getViewerName(files.viewerUserId) == null" @click="openText(formatPreviewData(files))">
                                    <img :src="previewIcon" class="preview-button" alt="">
                                </div>
                                <div class="edit-button-holder" v-if="files.name.toLowerCase().endsWith('png') || files.name.toLowerCase().endsWith('jpg') || files.name.toLowerCase().endsWith('jpeg') && getViewerName(files.viewerUserId) == null" @click="openImage(formatPreviewData(files))">
                                    <img :src="previewIcon" class="preview-button" alt="">
                                </div>
                                <div class="download-button-holder" @click="downloadFile(files)">
                                    <img :src="downloadBtn" class="download-button" alt="">
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <!-- Preview -->
        <div class="preview" v-if="active">
            <div class="viewer-overlay"></div>
            <div class="pdf-background" v-if="pdfView"></div>
            <div class="" :class="`${pdfView ? 'close-btn' : 'close-btn1'}`">
                <button type="button" class="btn btn-sm close-button" @click="close()">
                    <span class="mdi mdi-close-circle cancel"></span>
                </button>
            </div>

            <div class="pdf-holder" v-if="pdfView">
                <div class="doc-loader" v-if="docLoading"></div>
                <div class="pdf-topbar">
                    <div class="page-navigation">
                        <button type="button" class="btn btn-dark btn-sm nav-button mx-2" @click="changePage('first')">
                            First Page
                        </button>
                        <button type="button" class="btn btn-dark btn-sm nav-button" @click="changePage('previous')">
                            <div class=" nav-icon mdi mdi-menu-left"></div>
                        </button>
                        <label class="page-index">{{currentPage}}/{{numPages}}</label>
                        <button type="button" class="btn btn-dark btn-sm nav-button" @click="changePage('next')">
                            <div class=" nav-icon mdi mdi-menu-right"></div>
                        </button>
                        <button type="button" class="btn btn-dark btn-sm nav-button mx-2" @click="changePage('last')">
                            Last Page
                        </button>
                    </div>
                </div>
                <div class="pdf-viewer-holder">
                    <pdf class="pdf-viewer" :src="pdfFile" :page="currentPage" :resize="true" />
                </div>
            </div>

            <div v-if="imgView">
                <div class="image-holder">
                    <img class="image" :src="imgFile" alt="">
                    <div class="image-loader" v-if="imageLoading"></div>
                </div>
            </div>

            <div v-if="txtView">
                <div class="text-holder">
                    <object class="text-container" :data="txtFile"></object>
                    <div class="text-loader" v-if="textLoading"></div>
                </div>
            </div>
        </div>
        <div class="loader" v-if="loading"></div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import {
    decryptData
} from '../js/utils/encrypt';
import FolderOpenView from './FolderOpenView.vue';
import downloadBtn from '../assets/download-btn.png';
import docxIcon from '../assets/docx-icon.png';
import jpegIcon from '../assets/jpeg-icon.png';
import jpgIcon from '../assets/jpg-icon.png';
import pngIcon from '../assets/png-icon.png';
import txtIcon from '../assets/text-icon.png';
import pdfIcon from '../assets/pdf-icon.png';
import xlsxIcon from '../assets/excel-icon.png';
import pptIcon from '../assets/ppt-icon.png';
import csvIcon from '../assets/csv-icon.png';
import zipIcon from '../assets/zip-icon.png';
import pdfvuer from 'pdfvuer';
import folderOpenIcon from '../assets/folder-open.png';
import previewIcon from '../assets/preview-icon.png';
import folderImg from '../assets/folder.svg';

export default {
    data() {
        return {
            folderOpenIcon: folderOpenIcon,
            previewIcon: previewIcon,
            folderImg: folderImg,
            downloadBtn: downloadBtn,
            docxIcon: docxIcon,
            jpegIcon: jpegIcon,
            jpgIcon: jpgIcon,
            pngIcon: pngIcon,
            txtIcon: txtIcon,
            pdfIcon: pdfIcon,
            pptIcon: pptIcon,
            csvIcon: csvIcon,
            zipIcon: zipIcon,
            xlsxIcon: xlsxIcon,
            hideFolderOpenView: false,
            loading: false,
            FolderName: '',
            FolderID: '',
            employeeId: '',
            filesList: '',
            activeFolder: '',
            subFolder: '',
            permissions: [],
            pdfFile: this.pdfFile || '/example.pdf',
            imgFile: this.imgFile || '../assets/loading.gif',
            active: false,
            numPages: 0,
            currentPage: 1,
            pdfdata: undefined,
            pdfView: false,
            imgView: false,
            txtView: false,
            imageLoading: false,
            docLoading: false,
            txtFile: this.txtFile || '/example.txt',
            absolutePath: [],
            folder: [],
            files: [],
            subFolderData: [],
            viewerUsers: {},
        };
    },
    components: {
        FolderOpenView,
        pdf: pdfvuer
    },
    computed: {
        fileDataList() {
            if (this.activeFolder != null) {
                var refined = this.activeFolder.files[0];
            }
            var finalData = [];
            if (this.employeeId != 'ADM01') {
                for (let data in refined) {
                    if(refined[data].viewerUserId != null){
                        finalData.push(refined[data]);
                    }else{
                        let shortCode = this.employeeId.substring(0, 2);
                    for (let country in refined[data].regions) {
                        if (shortCode == refined[data].regions[country].short_code) {
                            finalData.push(refined[data]);
                            }
                        }
                    }
                }
                return finalData;
            } else {
                return refined;
            }
        },
        folderDataList() {
            console.log('activeFolder', this.activeFolder);
            if (this.activeFolder != null) {
                var subFolderData = this.activeFolder.subfolders;
            }
            var finalData = [];
            if (this.employeeId != 'ADM01') {
                for (let data in subFolderData) {
                    let shortCode = this.employeeId.substring(0, 2);
                    for (let country in subFolderData[data].regions) {
                        if (shortCode == subFolderData[data].regions[country].short_code) {
                            finalData.push(subFolderData[data]);
                        }
                    }
                }
                return finalData;
            } else {
                return subFolderData;
            }
        }
    },
    mounted() {
        var encryptedEmployeeID = localStorage.getItem('EmployeeID');
        const secretKey = process.env.KEY || 'myscecretkey';
        //Decrypting Permissions
        let mkLocalData = localStorage.getItem('Permissions');
        if (!mkLocalData) {
            mkLocalData = 'null';
        }
        this.permissions = decryptData(mkLocalData, secretKey);
        if (encryptedEmployeeID != null) {
            this.employeeId = decryptData(encryptedEmployeeID, secretKey).replace(/['"]+/g, '');
        }
        let folderPath = this.FolderName;
          axios.get(this.$hostName +`/folders/${folderPath}`).then(response => {
            this.filesList = response.data;
          });

        axios.get(this.$hostName + '/folders/base').then((response) => {
            var folderData = response.data.data.folder;
            var fileData = response.data.data.files;
            folderData.forEach((element) => {
                this.folder.push(element);
            });
            fileData.forEach((element) => {
                this.files.push(element);
            });
        });

    },
    methods: {
        reloadComponent() {
            this.absolutePath = [];
            this.hideFolderOpenView = false;
            this.loading = false;
            // this.folder = [];
            // this.files = [];
            // this.absolutePath.pop();
            // axios.get(this.$hostName + '/folders/base').then((response) => {
            //         var folderData = response.data.data.folder;
            //         var fileData = response.data.data.files;
            //         folderData.forEach((element) => {
            //             this.folder.push(element);
            //         });
            //         fileData.forEach((element) => {
            //             this.files.push(element);
            //         });
            //         console.log('checking this', this.folder);

            //         // var pathdata = {
            //         //     path: this.FolderName,
            //         //     data: this.subFolderData
            //         // };
            //         // this.absolutePath.push(pathdata);

            //     })
            //     .catch((error) => {
            //         console.log(error);
            //     })
            //     .finally(() => {
            //         console.log('axios complete');
            //         this.loading = false;
            //     });
        },
        formatPreviewData(data) {
            var finalFormat = {
                foldername: this.FolderName,
                filename: data.name
            };
            return finalFormat;
        },
        imageLoad() {
            return this.imgFile;
        },
        close() {
            this.active = false;
            this.pdfView = false;
            this.imgView = false;
            this.txtView = false;
            this.currentPage = 1;
            this.imgFile = '';
        },
        openImage(data) {
            this.imageLoading = true;
            this.imgView = true;
            this.active = true;
            let finalPath = '';
            for (let i = 1; i < this.absolutePath.length; i++) {
                const currentPath = this.absolutePath[i].path;
                if (i !== 1) {
                    finalPath += '/';
                }
                finalPath += currentPath;
            }
            var formData = {
                folderName: finalPath,
                fileName: data['filename']
            };
            axios({
                url: this.$hostName + '/files/download',
                method: 'POST',
                responseType: 'blob',
                data: formData,
            }).then((response) => {
                const binaryResponse = new Blob([response.data]);
                var fileURL = window.URL.createObjectURL(binaryResponse);
                this.imgFile = fileURL;
            }).finally(() => {
                this.active = true;
                this.imgView = true;
                this.imageLoading = false;
            });
        },
        openText(data) {
            this.textLoading = true;
            this.txtView = true;
            this.active = true;
            let finalPath = '';
            for (let i = 1; i < this.absolutePath.length; i++) {
                const currentPath = this.absolutePath[i].path;
                if (i !== 1) {
                    finalPath += '/';
                }
                finalPath += currentPath;
            }
            var formData = {
                folderName: finalPath,
                fileName: data['filename']
            };
            axios({
                url: this.$hostName + '/files/download',
                method: 'POST',
                responseType: 'blob',
                data: formData,
            }).then((response) => {
                const binaryResponse = new Blob([response.data]);
                var fileURL = window.URL.createObjectURL(binaryResponse);
                this.txtFile = fileURL;
            }).finally(() => {
                this.active = true;
                this.txtView = true;
            });
        },
        openDocument(data) {
            let finalPath = '';
            for (let i = 1; i < this.absolutePath.length; i++) {
                const currentPath = this.absolutePath[i].path;
                if (i !== 1) {
                    finalPath += '/';
                }
                finalPath += currentPath;
            }
            var formData = {
                folderName: finalPath,
                fileName: data['filename']
            };
            this.active = true;
            this.docLoading = true;
            axios({
                url: this.$hostName + '/files/download',
                method: 'POST',
                responseType: 'blob',
                data: formData,
            }).then((response) => {
                const binaryResponse = new Blob([response.data]);
                var fileURL = window.URL.createObjectURL(binaryResponse);
                this.pdfFile = fileURL;
                var self = this;
                self.pdfdata = pdfvuer.createLoadingTask(fileURL);
                self.pdfdata.then(pdf => {
                    this.numPages = pdf.numPages;
                });
                this.pdfView = true;
            }).finally(() => {
                this.docLoading = false;
            });
        },
        changePage(type) {
            if (type == 'next') {
                if (this.currentPage < this.numPages)
                    this.currentPage = this.currentPage + 1;
            } else if (type == 'previous') {
                if (this.currentPage > 1)
                    this.currentPage = this.currentPage - 1;
            } else if (type == 'first') {
                this.currentPage = 1;
            } else if (type == 'last') {
                this.currentPage = this.numPages;
            }
        },
        getImgUrl(filename) {
            try {
                return require(`C:/ProgramData/Scala/hrm-portal/assets/employee/pics/${filename}`);
            } catch (_) {
                return require('../assets/imagealt.png');
            }
        },
        downloadFile(fileData) {
            let finalPath = '';
            for (let i = 1; i < this.absolutePath.length; i++) {
                const currentPath = this.absolutePath[i].path;
                if (i !== 1) {
                    finalPath += '/';
                }
                finalPath += currentPath;
            }
            let path = finalPath + '/' + fileData.name;
            var formData = {
                filePath: path
            };
            axios({
                url: this.$hostName + '/files/downloadAll',
                method: 'POST',
                responseType: 'blob',
                data: formData,
            }).then((response) => {
                const binaryResponse = new Blob([response.data]);
                var fileURL = window.URL.createObjectURL(binaryResponse);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                var fileName = fileData.name;
                fileLink.setAttribute('download', fileName);
                document.body.appendChild(fileLink);
                fileLink.click();
                fileLink.remove();
            });
        },
        OnFolderOpen(folderOpen, data) {
            this.subFolderData = data;
            var pathdata = {
                path: 'root',
                data: this.folder
            };
            this.absolutePath.push(pathdata);
            this.hideFolderOpenView = folderOpen;
            this.FolderName = data.name;
            pathdata = {
                path: this.FolderName,
                data: data
            };
            this.absolutePath.push(pathdata);
            this.FolderID = data.id;
            this.activeFolder = data;
        },
        navigate(data) {
            this.FolderName = data.path;
            if (data.path == 'root') {
                this.hideFolderOpenView = false;
                this.absolutePath = [];
            } else {
                for (let i = 0; i < this.absolutePath.length; i++) {
                    if (this.absolutePath[i].path == data.path) {
                        for (let j = i; j < this.absolutePath.length; j++) {
                            this.absolutePath.splice(j, this.absolutePath.length);
                            break;
                        }
                    }
                }

                this.openSubFolder(data.data);
            }
        },
        openSubFolder(data) {
            var pathdata = {
                path: data.name,
                data: data
            };
            this.absolutePath.push(pathdata);
            this.FolderName = data.name;
            this.FolderID = data.id;
            this.FolderID = data.id;
            this.activeFolder = data;
        },
        getViewerName(viewerId) {

            if(viewerId == null){
                return null;
            }
            if (this.viewerUsers[viewerId]) {
                return this.viewerUsers[viewerId];
            }

            // Fetch employees if not already loaded
            axios.get(this.$hostName + '/employees/list')
                .then(response => {
                    // Create a mapping of user IDs to names
                    this.viewerUsers = response.data.users.reduce((acc, user) => {
                        acc[user.id] = user.name + ' - ' + user.employee_id;
                        return acc;
                    }, {});
                })
                .catch(error => {
                    console.error('Error fetching employees:', error);
                });

            return this.viewerUsers[viewerId] || viewerId;
        },
    }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 575.98px) {
    .create-folder-button {
        background-color: #33a544;
        color: #fff;
        font-size: 10px;
        width: 80px;
        height: 30px;
        border-radius: 4px;
        padding: 4px 8px;
        margin-right: 2px !important;
        cursor: pointer;
    }

    .files-table {
        height: 79vh !important;
    }

    .pdf-background {
        z-index: -1;
    }

    .previewBtn {
        left: 10px;
        position: initial !important;
        margin-top: 20px;
        height: 6%;
        width: 100%;
        margin-top: 4px !important;
    }

    .btn-holder {
        float: right;
        flex: 0 0 100% !important;
    }

    .nav-button {
        font-size: 12px;
    }

    .pdf-topbar {
        width: 96% !important;
        height: 54px;
        position: absolute;
        top: 140px !important;
        left: calc(50%) !important;
        transform: translate(-50%) !important;
        background-color: white;
        text-align: center;
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
    }

    .close-button {
      height: 40px !important;
      width: 40px !important;
    }

    .page-navigation {
        width: 100% !important;
        color: black !important;
        flex-wrap: nowrap !important;
        align-items: center !important;

        button {
          font-size: 14px;
          overflow-y: hidden;
        }
    }

    .pdf-viewer {
        left: calc(50%) !important;
        top: 423px !important;
        width: 300px !important;
    }

    .image-holder {
        left: calc(50%) !important;
    }

    .text-holder {
        background-color: white;
        left: calc(50%) !important;
        width: 80% !important;
        height: 80% !important;
    }

    .close-btn {
        position: absolute;
        top: 50px !important;
        left: 85% !important;
        z-index: 999;
    }

    .close-btn1 {
        position: absolute !important;
        top: 226px !important;
        left: 85% !important;
    }

    .cancel {
        font-size: 45px !important;
        color: #d82d28;
        position: absolute;
        top: 50%;
    }

    .cancel:hover {
        color: #b60a04;
    }

    .flex-nowrap {
      display: flex !important;
      flex-wrap: nowrap !important;
      flex: 0 0 100% !important;
    }

    .open-folder-button {
      height: 15px !important;
      width: 20px !important;
    }

    .directory {
      display: none;
    }
}

@media (min-width: 768px) and (max-width: 991.98px) {
    .close-btn1 {
        position: absolute !important;
        top: 36px !important;
    }

    .cancel {
        font-size: 40px !important;
        color: #d82d28;
        position: absolute !important;
    }

    .cancel:hover {
        color: #b60a04;
    }

    .close-btn {
        position: absolute !important;
        top: 50px !important;
        left: 85% !important;
        z-index: 999;
    }

    .pdf-background {
        z-index: -1;
    }

    .pdf-topbar {
        width: 70% !important;
        height: 48px !important;
        position: absolute;
        top: 140px !important;
        background-color: white;
        text-align: center;
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
    }

    .page-navigation {
        width: 100% !important;
        left: 50%;
        transform: translate(-50%);
        position: absolute;
        color: white;
        top: 8px !important;
    }

    .pdf-viewer {
        top: 600px !important;
        width: 500px !important;
    }

    .file-type-holder {
      flex: 0 0 7% !important;
    }

    .button-holder {
      padding-right: 10px;
    }

}

.country-icon-holder {
    display: flex;
}

.checkbox-container {
    display: flex;
    flex-wrap: wrap;
}

.paths {
    margin-left: 2%;
    margin-right: 2%;
    font-size: 20px;
    width: 100%;
    display: flex;
}

.path:hover {
    cursor: pointer;
}

.fileName {
    font-size: 18px;
    word-break: break-word;
}

label {
    display: block;
    margin: 0;
}

.files-table {
    height: 82vh;
    overflow: auto;
    padding: 10px;
    font-size: 12px;
}

.folderImg {
    width: 50px;
    height: 50px;
    margin-right: 10px;
}

.file-row {
    box-shadow: 2px 3px 9px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    width: 100%;
    padding: 10px 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.delete-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.button-holder {
    display: flex;
    justify-content: flex-end;

}

.open-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    width: 90px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #DDE2FF;
    margin-left: 10px;
}

.open-button {
    color: #4E65FF;
    font-size: 16px;
}

.open-button-holder:active {
    transform: scale(0.9);
}

.open-button-holder {
    transition: transform 100ms ease-in-out;
}

.delete-button-holder:active {
    transform: scale(0.9);
}

.delete-button-holder {
    transition: transform 100ms ease-in-out;
}

.delete-button-holder:hover {
    cursor: pointer;
}

.open-button-holder:hover {
    cursor: pointer;
}

.open-button:hover {
    cursor: pointer;
}

.delete-button {
    height: 30px;
    width: 30px;
}

.create-folder-button {
    background-color: #33a544;
    text-align: center;
    color: #fff;
    font-size: 14px;
    width: 80px;
    height: 30px;
    border-radius: 4px;
    padding: 4px 8px;
    margin-right: 20px;
    margin-left: 20px;
    cursor: pointer;
}

.previewBtn {
    background-color: #EE3234;
    color: #fff;
    padding: 5px;
    margin-top: 0.2rem !important;
    margin-left: 10px;
}

.pdf-background {
    background-color: #505257;
    height: 97%;
    width: 36%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.image-loader {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url("../assets/loading.gif");
    background-size: 150px;
    background-repeat: no-repeat;
    background-position: 50%;
    z-index: 999;
}
.text-loader{
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url("../assets/loading.gif");
    background-size: 150px;
    background-repeat: no-repeat;
    background-position: 50%;
    z-index: 999;
}

.doc-loader {
    // background-color: rgba(0, 0, 0, 0.5);
    background-image: url("../assets/loading.gif");
    background-size: 150px;
    background-repeat: no-repeat;
    background-position: 50%;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    backdrop-filter: blur(5px);
    z-index: 1;
}

.image-holder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 90%;
}

.text-holder {
    position: absolute;
    top: 52%;
    left: 50%;
    background-color: white;
    transform: translate(-50%, -50%);
    width: 60%;
    height: 90%;
}

.text-container {
    height: 100%;
    width: 100%;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: contain
}

.btn-holder {
    float: right;
    position: relative;
    flex: 0 0 25%;
}

.nav-icon {
    font-size: 26px;
    position: relative;
    top: -10px;
}

.close-icon {
    font-size: 26px;
    position: relative;
    left: -7px;
    top: -9px;
}

.close-button {
    background-color: white;
    height: 20px;
    width: 20px;
    position: absolute;
    border-radius: 50%;
    padding: 0;
}

.cancel {
    font-size: 30px;
    color: #d82d28;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
}

.cancel:hover {
    color: #b60a04;
}

.nav-button {
    height: 30px;
}

.viewer-overlay {
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    backdrop-filter: blur(5px);
}

.pdf-topbar {
    width: 32%;
    height: 40px;
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translate(-50%);
    background-color: white;
    text-align: center;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 15px;
}

.pdf-viewer {
    width: 30%;
    position: absolute;
    left: 50%;
    top: 52%;
    transform: translate(-50%, -50%);
}

.page-navigation {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    color: white;
    top: 4px;
}

.page-index {
    width: 60px;
    text-align: center;
    color: #000;
}

.close-btn {
    position: absolute;
    top: 4px;
    left: 67.5%;
    z-index: 999;
}

.close-btn1 {
    position: absolute;
    top: 8px;
    left: 90%;
    z-index: 999;
}

.delete-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.delete-button-holder:active {
    transform: scale(0.9);
}

.delete-button-holder {
    transition: transform 100ms ease-in-out;
}

.delete-button-holder:hover {
    cursor: pointer;
}

.delete-button {
    height: 30px;
    width: 30px;
}

.download-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.download-button-holder:active {
    transform: scale(0.9);
}

.download-button-holder {
    transition: transform 100ms ease-in-out;
}

.download-button-holder:hover {
    cursor: pointer;
}

.download-button {
    height: 30px;
    width: 20px;
}

.edit-button-holder {
    box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 5px;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.edit-button-holder:active {
    transform: scale(0.9);
}

.edit-button-holder {
    transition: transform 100ms ease-in-out;
}

.edit-button-holder:hover {
    cursor: pointer;
}

.edit-button {
    height: 30px;
    width: 30px;
}

.preview-button {
    height: 20px;
    width: 30px;
}

.open-folder-button {
    height: 25px;
    width: 30px;
}

th {
    margin: 0;
}

tr {
    text-align: left;
}

td {
    text-align: left;
    vertical-align: baseline !important;
}

td:first-child {
    vertical-align: middle !important;
}

thead {
    top: 0;
    position: sticky;
}

table {
    border-collapse: separate;
    border-spacing: 0 10px;
}

.table {
    width: 98%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0;
}

table td {
    border-top: 0;
}

/* The Modal (background) */
.folder-name-holder {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    padding: 10px 0px;
}

.folder-name-holder input {
    flex: 0 75%;
}

.folder-name-holder label {
    flex: 0 25%;
    font-size: 14px;
}

.modal {
    display: flex;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgba(0, 0, 0, 0.4);
    /* Black w/ opacity */
}

/* Modal Content/Box */
.background {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
}

.modal-content {
    z-index: 3;
    height: 380px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 10% auto;
    /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 40% !important;
    /* Could be more or less, depending on screen size */
    background-color: white;
}

.file-modal-content {
    z-index: 3;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 10% auto;
    /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 40% !important;
    /* Could be more or less, depending on screen size */
    background-color: white;
}

.file-modal-upload {
    z-index: 3;
    height: 370px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 10% auto;
    /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 40% !important;
    /* Could be more or less, depending on screen size */
    background-color: white;
}

/* The Close Button */
.close {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
    text-shadow: 0;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.modal-header {
    padding: 2px 16px;
    background-color: #d05959;
    color: white;
}

.modal-body {
    padding: 2px 16px;
}

.modal-body label {
    font-size: 14px;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 2px 16px;
    background-color: #d05959;
    color: white;
}

.submit-button {
    padding: 10px 20px;
    background-color: #5cb85c;
    border: none;
    color: white;
    font-size: 16px;
    cursor: pointer;
}

.submit-button:hover {
    background-color: #4CAF50;
}

.files {
    display: flex;
    align-items: center;
    height: 80px;
    box-shadow: 2px 3px 9px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: bold;
    margin-bottom: 10px;
    flex-wrap: nowrap;
}

.file-Name {
    position: relative;
    flex: 0 0 70%;
    font-size: 16px;
}

.button-holder {
    flex: 0 0 25%;
    display: flex;
    justify-content: flex-end;
}

.fileImg {
    height: 40px;
    margin-right: 10px;
}

.file-type-holder {
    flex: 0 0 5%;
}

.flex-nowrap {
  display: flex;
  flex: 0 0 75%;
  align-items: center;
}

@media only screen and (max-width: 575.98px) {
    .fileName {
        font-size: 14px !important;
        margin: 0 !important;
        padding-left: 10px;
    }

    .fileNameContainer {
      flex: 0 0 80% !important;
    }

    .file-Name {
      font-size: 14px;
      flex: 0 0 80% !important;
      padding-left: 10px;
      word-break: break-word;
    }

    .files {
      padding: 7px 9px !important;
      flex-wrap: wrap;
      height: unset;
    }

    .file-row {
      padding: 10px;
    }

    .fileImg {
      // height: 24px;
      // margin-right: 10px;
      width: 30px;
      height: unset;
    }


    .folderImg {
      width: 30px;
      height: unset;
    }

    .file-type-holder {
      flex: 0 0 9%;
    }

    .pathUrl {
      font-size: 14px;
      max-width: 250px;
      flex-wrap: nowrap !important;
      align-items: center;
      overflow-x: auto;
      padding-top: 15px;

      .path {
        // width: 150%;
      }
    }

    .search {
      white-space: nowrap;
      width: 95% !important;
    }

    .paths {
      label {
        padding-top: 10px !important;
        width: 54px;
      }
    }

    .preview-button {
      height: 16px;
      width: 22px;
    }

    .download-button {
      height: 16px;
      width: 14px;
    }

    .button-holder {
      margin-top: 10px !important;
      margin-left: auto;
      flex: 0 0 100% !important;
    }

    .edit-button-holder {
      width: 40px;
      height: 30px;
    }

    .download-button-holder {
      width: 40px;
      height: 30px;
    }

    .manage-folder {
        height: 100% !important;
    }

    .upload-file-button {
        background-color: #33a544;
        color: #fff;
        font-size: 10px;
        width: 80px;
        height: 30px;
        border-radius: 4px;
        padding: 4px 8px;
        margin-right: 2px !important;
        cursor: pointer;
    }
}

.swal2-popup {
    font-family: Arial, sans-serif;
}

/* Style for the checkboxes */
.swal2-checkboxes label {
    display: block;
    margin-bottom: 10px;
    color: #777;
}

.swal2-checkboxes input[type="checkbox"] {
    margin-right: 5px;
}

.back-btn {
    border: 1px solid #000000;
    border-radius: 50%;
    padding-left: 5px;
    padding-right: 5px;
}

.back-btn:hover {
    background-color: #626262;
    border: 1px solid #ffffff;
    color: #fff;
    cursor: pointer;

}

.upload-file-button {
    background-color: #33a544;
    text-align: center;
    color: #fff;
    font-size: 14px;
    width: 80px;
    height: 30px;
    border-radius: 4px;
    padding: 4px 8px;
    margin-right: 20px;
    cursor: pointer;
}

.manage-folder {
    font-family: 'Montserrat';
    position: relative;
    padding-top: 1.5rem;
    height: 100vh;
    left: 60px;
    width: calc(100% - 60px);
    // overflow: hidden;
}

.icon {
    font-size: 25px;
}

.search {
    width: 100%;
    flex-grow: 1;
    height: 100%;
    position: relative;
    display: flex;

    .icon {
        width: 40px;
        height: 100%;
        font-size: 24px;
        color: #000;
        // opacity: .5;
        position: relative;
        float: left;

        display: flex;
        align-items: center;
        justify-content: center;
    }

    input {
        width: 220px;
        height: 100%;
        position: relative;
        float: left;
        font-size: 14px;
        -webkit-appearance: none;
        outline: 0;
        border-width: 0 0 2px;
        border-color: rgb(40, 40, 102);
        background-color: transparent;
        color: $general-black-light;
        flex-grow: 1;

        &::placeholder {
            opacity: 0.6;
            font-style: italic;
        }
    }
}
</style>
